import { render, staticRenderFns } from "./GroupExtends.vue?vue&type=template&id=1a863c5a"
import script from "./GroupExtends.vue?vue&type=script&lang=js"
export * from "./GroupExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports